var _ellipse, _ellipse2, _path, _path2, _path3, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _polygon2, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle3, _path11, _path12, _path13, _path14, _path15, _path16, _circle4, _path17, _polygon3, _rect15, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawLightTheFireGt58(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1124,
    height: 776,
    viewBox: "0 0 1124 776",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_the_fire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 562,
    cy: 739,
    rx: 562,
    ry: 37,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 534,
    cy: 216,
    rx: 58,
    ry: 53,
    fill: "#6c63ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M674.5,763.5s-123.5,49.5-211,1l.81-14,7.54-130,7.13-123,8.52-147h164l7.88,147,6.6,123,6.97,130Z",
    transform: "translate(-38 -62)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M463.5,350.5",
    transform: "translate(-38 -62)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M674.5,763.5s-113.5,50.5-211,1l.81-14H672.95Z",
    transform: "translate(-38 -62)",
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "627.98 558.5 433.85 558.5 440.98 435.5 621.38 435.5 627.98 558.5",
    fill: "#6c63ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 272.5,
    width: 184,
    height: 20,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 205.5,
    width: 184,
    height: 20,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 455.5,
    y: 225.5,
    width: 11,
    height: 52,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 484.5,
    y: 225.5,
    width: 11,
    height: 52,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 513.5,
    y: 225.5,
    width: 11,
    height: 52,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 542.5,
    y: 225.5,
    width: 11,
    height: 52,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 571.5,
    y: 225.5,
    width: 11,
    height: 52,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 484.5,
    y: 146,
    width: 11,
    height: 68.5,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 513.5,
    y: 146,
    width: 11,
    height: 68.5,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 542.5,
    y: 146,
    width: 11,
    height: 68.5,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 571.5,
    y: 146,
    width: 11,
    height: 68.5,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 600.5,
    y: 225.5,
    width: 11,
    height: 52,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 154,
    width: 11,
    height: 61,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 154,
    width: 11,
    height: 61,
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "624 165.5 440 165.5 440 105.5 532 31 624 105.5 624 165.5",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 215,
    r: 154.69512,
    fill: "#6c63ff",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 215,
    r: 215,
    fill: "#6c63ff",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.40863,754.73447c6.07317,22.45005,26.87512,36.35394,26.87512,36.35394s10.95541-22.49485,4.88225-44.94491-26.87512-36.35394-26.87512-36.35394S83.33547,732.28441,89.40863,754.73447Z",
    transform: "translate(-38 -62)",
    fill: "#8985a8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.33272,749.90971c16.66484,16.22255,18.70033,41.1604,18.70033,41.1604S92.04949,789.706,75.38464,773.48344,56.68431,732.323,56.68431,732.323,81.66787,733.68715,98.33272,749.90971Z",
    transform: "translate(-38 -62)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.75735,722.4082c-8.95314,33.09618-39.61966,53.59348-39.61966,53.59348s-16.15062-33.16222-7.19748-66.2584,39.61966-53.59348,39.61966-53.59348S363.71049,689.312,354.75735,722.4082Z",
    transform: "translate(-38 -62)",
    fill: "#8985a8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.30876,722.4082c8.95314,33.09618,39.61966,53.59348,39.61966,53.59348s16.15062-33.16222,7.19748-66.2584-39.61967-53.59348-39.61967-53.59348S264.35562,689.312,273.30876,722.4082Z",
    transform: "translate(-38 -62)",
    fill: "#8985a8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.46476,715.29547c24.56755,23.91552,27.56829,60.67923,27.56829,60.67923s-36.83111-2.011-61.39865-25.92651S225.06611,689.369,225.06611,689.369,261.89722,691.38,286.46476,715.29547Z",
    transform: "translate(-38 -62)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M341.60134,715.29547C317.0338,739.211,314.03305,775.9747,314.03305,775.9747s36.83112-2.011,61.39866-25.92651S403,689.369,403,689.369,366.16889,691.38,341.60134,715.29547Z",
    transform: "translate(-38 -62)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M946.958,427.97294c-7.88435-13.32212-23.48292-13.943-23.48292-13.943s-15.19991-1.94375-24.95056,18.346c-9.08838,18.91172-21.63151,37.17136-2.01934,41.59846l3.54253-11.02593,2.19386,11.8468a76.7367,76.7367,0,0,0,8.39132.14341c21.00305-.6781,41.00527.19839,40.36123-7.33838C950.138,457.58123,954.54432,440.79148,946.958,427.97294Z",
    transform: "translate(-38 -62)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.04595,
    cy: 383.50128,
    r: 20.35767,
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M916.71782,458.76461s9.25348,21.59146-3.0845,25.90976l12.338,40.71533,20.97457-1.2338,5.55209-13.57178-1.2338-20.35766-1.8507-13.57178s-12.95488,3.0845-11.72108-19.74077Z",
    transform: "translate(-38 -62)",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M911.78262,484.05747s-20.35766-1.8507-18.507,12.95488,3.7014,17.89007,3.7014,17.89007l1.8507,22.20836-11.10419,6.78589H877.23628s-32.07875,7.40279-16.03937,15.42248,21.59146-6.169,21.59146-6.169,29.61115,0,31.46185-4.9352S911.78262,484.05747,911.78262,484.05747Z",
    transform: "translate(-38 -62)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M951.26416,477.88848s19.12387-6.78589,20.35767,8.01969,1.23379,16.03937,1.23379,16.03937l3.7014,20.97456s7.40279,18.507,7.40279,24.05907,5.55209,22.82526,5.55209,22.82526,7.40279,24.05906-.6169,23.44216-9.25349-25.90976-9.25349-25.90976l-16.65627-33.31254-4.93519-20.35767Z",
    transform: "translate(-38 -62)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M914.86712,481.58987h-4.93519l-.6169,25.90976s-8.01969,11.10418,1.8507,20.97457l2.46759,16.03937,45.03363-1.8507,3.08449-16.65627s6.169-13.57178-2.46759-25.90976L951.26416,474.804h-4.31829s10.00158,36.87706-11.10419,37.63084C918.56851,513.05172,914.86712,481.58987,914.86712,481.58987Z",
    transform: "translate(-38 -62)",
    fill: "#d0cde1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M916.10092,541.42907l-3.7014,12.338S835.28715,770.9155,858.72931,776.46759s56.13781,12.95488,59.2223,7.40279,19.12387-167.79653,19.12387-167.79653-2.46759,169.64723,5.55209,169.64723,61.073,1.23379,64.1575-6.78589-27.76046-222.70054-45.65053-227.63573l-4.93519-11.10418Z",
    transform: "translate(-38 -62)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M960.51764,535.26008l-48.735,1.8507s-2.22426,16.65627,0,16.65627c.6169,0,51.20262,4.3183,50.58572-3.08449S960.51764,535.26008,960.51764,535.26008Z",
    transform: "translate(-38 -62)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.38417,
    cy: 352.09743,
    r: 11.27862,
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M912.91833,411.12937a11.27906,11.27906,0,0,1,10.0914-11.21521,11.27862,11.27862,0,1,0,0,22.43042A11.279,11.279,0,0,1,912.91833,411.12937Z",
    transform: "translate(-38 -62)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "905.472 364.689 890.062 356.616 868.78 359.919 864.377 379.366 875.338 378.944 878.4 371.799 878.4 378.826 883.457 378.632 886.392 367.257 888.227 379.366 906.206 378.999 905.472 364.689",
    fill: "#2f2e41"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 863.75688,
    y: 494.97263,
    width: 5.86921,
    height: 88.03821,
    transform: "translate(-156.96056 212.12145) rotate(-16.83579)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M873.43778,477.54775A24.01042,24.01042,0,0,1,827.47517,491.456c-3.84066-12.69223,8.69714-54.159,8.69714-54.159S869.59712,464.85553,873.43778,477.54775Z",
    transform: "translate(-38 -62)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M866.43519,484.75374a16.34564,16.34564,0,1,1-31.2901,9.46837c-2.61461-8.64052,5.92078-36.87,5.92078-36.87S863.82058,476.11322,866.43519,484.75374Z",
    transform: "translate(-38 -62)",
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawLightTheFireGt58);
export default __webpack_public_path__ + "static/media/undraw_light_the_fire_gt58.c7187fa0087de171514845e1f8460062.svg";
export { ForwardRef as ReactComponent };